module.exports = __webpack_public_path__ + "static/media/A4.3c81e089.jpg";